<div class="db-wordpress-installation-loading-dialog-wrap">
<!--  <db-loading-screen *ngIf="!loadingContent" [ngClass]="{'hidden':!loading && !(ongoingActivity$ | async)}" [loadingMessage]=" '<div>Creating website</div><span>Please wait while we create your blank WordPress website.</span>'" [pageBlocker]="true"></db-loading-screen>-->
<!--  *ngIf="!loadingContent" [ngClass]="{'hidden':!loading && !(ongoingActivity$ | async)}"  -->
  <div class="db-loading-wrap" [ngClass]="{'inside-page' : insidePageContent, 'inside-page-static': insidePageStatic}">
    <div class="db-loading-title" [innerHTML]="loadingTitle || ('text_loadingTitle' | dbText)" ></div>
    <div class="db-loading-desc">{{ 'text_loadingDesc' | dbText}}</div>
    <div class="db-loading-steps">
      <div class="db-loading-img">
        <img id="loadingImg" [src]=" step1 === 'loading' ? 'assets/images/loading/hosting.svg' : step2 === 'loading' ? 'assets/images/loading/wp_logo.svg' : 'assets/images/loading/finalizing.svg'"/>
      </div>
      <div>
        <div class="db-loading-step" *ngFor="let step of steps; let i = index" [ngClass]="{'active' : i==0 && (step1 === 'done' || step1 === 'loading') || i==1 && (step2 === 'done' || step2 === 'loading') || i==2 && (step3 === 'done' || step3 === 'loading') }">
          <div><span class="db-row"><span>{{i+1}}</span></span><span class="db-step">{{step | dbText}}</span></div>
          <div class="db-loading">
            <span *ngIf="i==0 && step1 === 'loading' || i==1 && step2 === 'loading' ||  i==2 && step3 === 'loading'"><db-loading-circular-spinner [color]="'gray'" [default]="false"></db-loading-circular-spinner></span>
            <span *ngIf="i==0 && step1 === 'done'  || i==1 && step2 === 'done' || i==2 && step3 === 'done' "><i class="db-icon db-icon-checkbox-round"></i></span>
          </div>
        </div>

    </div>
    </div>
  </div>
</div>


